import React from 'react'
import { firebaseAuth, db } from 'config/firebase'
import queryString from 'query-string'

export default (WrappedComponent, authFunction) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        user: null
      };
    }

    componentDidMount() {
      console.log(this.props)
      if (this.props.location.search) {
        const parsed = queryString.parse(this.props.location.search)
        if (parsed.token) {
          firebaseAuth().signInWithCustomToken(parsed.token)
          .catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(`${errorCode}: ${errorMessage}`)
            // ...
          })
        }

        if (parsed.ref) {
            Cookies.set('referralSlug', parsed.ref, { expires: 365 })
        }
      }

      firebaseAuth().onAuthStateChanged(authUser => {
        if (authUser) {
          db.ref(`users/${authUser.uid}`).on('value', snapshot => {
            const user = snapshot.val() || {}
            const authResult = authFunction(user)
            if (authResult) {
              this.setState({ user: user })          
            }
          })
        }
      })
    }

    logout() {
      firebaseAuth().signOut()
      .then(() => {
        // Sign-out successful.
        window.location = '/'
      })
      .catch((error) => {
        console.log(error)
        // An error happened.
      })

    }

    render() {
      return <WrappedComponent user={this.state.user} logout={this.logout} {...this.props} />;
    }
  }
}

//////////////
// Auth Types
//////////////

export const adminAuth = (user) => {
  if (!user || !user.isAdmin) {
    window.location = '/login'
    return false
  }
  return true
}

export const loggedInAuth = (user) => {
  if (!user) {
    window.location = '/login'
    return false
  }
  return true
}

export const publicAuth = (user) => true



// WEBPACK FOOTER //
// ./src/components/hocs/withAuth.js